import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { traceRouting } from '../../utils/routingDebug';

/**
 * Listens for `auth:terms-required` events dispatched by apiClient when a 451
 * TERMS_NOT_ACCEPTED is received. SPA-navigates to /onboarding/terms instead
 * of the previous `window.location.href` hard nav.
 *
 * Mounted once in App.jsx at the root. Renders nothing.
 *
 * Doctrine: PRP flash-diagnostics-onboarding-flow (2026-05-26, D2).
 */
const TermsRedirectListener = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handler = (event) => {
      if (location.pathname === '/onboarding/terms') return; // already there
      traceRouting('TermsRedirectListener', 'Navigate', {
        to: '/onboarding/terms',
        reason: '451_TERMS_NOT_ACCEPTED',
        endpoint: event?.detail?.endpoint,
      });
      navigate('/onboarding/terms', { replace: true });
    };

    window.addEventListener('auth:terms-required', handler);
    return () => window.removeEventListener('auth:terms-required', handler);
  }, [navigate, location.pathname]);

  return null;
};

export default TermsRedirectListener;
